export default __webpack_public_path__ + "static/media/process_4.6b36331b.png";